import gsap from 'gsap'
import Base from '../../../src/js/classes/Base'

export default class CustomEnquiryForm extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				closes: '.c-CustomEnquiryForm__controls__close',
			},
			options: {},
			classes: {
				customEnquiryOpen: 'custom-enquiry-open',
			},
			state: {},
		})
	}

	init() {
		this.elements.closes = gsap.utils.toArray(this.elements.closes)
		this.addEvents()
	}

	addEvents() {
		this.elements.closes.forEach((close) => {
			close.addEventListener('click', this.onClickClose.bind(this))
		})
	}

	onClickClose(e) {
		e.preventDefault()
		document.body.classList.remove(this.classes.customEnquiryOpen)
	}

	removeEvents() {
		this.elements.closes.forEach((close) => {
			close.removeEventListener('click', this.onClickClose.bind(this))
		})
	}

	resize() {}

	update() {}

	unmount() {
		this.removeEvents()
	}
}
